/* eslint-disable complexity */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import React, { useEffect } from 'react';
import { Field, reduxForm } from 'redux-form';
import moment from 'moment';
import LabeledRadioButton from '@tcp/core/src/components/common/atoms/LabeledRadioButton';

import PropTypes from 'prop-types';
import { getIconPath } from '@tcp/core/src/utils/utils';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import Image from '@tcp/core/src/components/common/atoms/Image';
import Button from '@tcp/core/src/components/common/atoms/Button';
import FormPageHeading from '../../common/molecule/FormPageHeading';
import RecentOrders from '../molecules/RecentOrders';
import OrdersLinks from '../molecules/OrdersLinks';
import PastOrders from '../molecules/PastOrders';
import OrderPreviewItemsList from '../molecules/OrderPreviewItemsList';
import RecentOrdersSkeleton from '../skeleton/RecentOrdersSkeleton.view';
import styles from './styles/OrdersList.style';
import OrderPreviewItemsListSkeleton from '../skeleton/OrderPreviewItemsListSkeleton.view';
import OrderListWithDetails from '../molecules/OrderListWithDetails';
import EmptyOrdersList from '../molecules/EmptyOrdersList';
import Anchor from '../../../../common/atoms/Anchor';
import BodyCopy from '../../../../common/atoms/BodyCopy';
import BIAOrderHistory from '../molecules/BuyItAgainOrders';
import LoaderSkelton from '../../../../common/molecules/LoaderSkelton';
import ReactToolTip from '../../../../common/atoms/ReactToolTip';
import { isMobileWeb } from '../../../../../utils';
import { modalStyles } from '../../../CnC/CartItemTile/molecules/CartItemTile/styles/CartItemNewTileUtils';
import Modal from '../../../../common/molecules/Modal';
import { getLocalStorage, setLocalStorage } from '../../../../../utils/localStorageManagement';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  getLabelWithDefaultValue,
} from '../../../../../utils/labels/labelUtilty';
import {
  ACCOUNT_ORDERS_LABEL,
  OrderDetailLabels,
  lblEmptyOrdersText1,
  lblEmptyOrdersText2,
  lblEmptyOrdersText4,
  lblExtendedLast12Months,
  lblExtendedLast6Months,
  lblOrdersHeading,
  lblOrdersHeadingHistory,
  lblOrdersHeadingUpcoming,
  lblOrdersLoadMore,
} from '../../OrderDetails/container/OrderDetails.labels';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblBack,
} from '../../../../../utils/labels/globalActions.labels';
import {
  ACCOUNT_OVERVIEW_LABEL,
  OrderTileLabels,
  lblOverviewOrderHeading,
} from '../../common/organism/OrdersTile/container/OrderTile.labels';

/**
 * This component will render OrdersList component
 * @param { string, object }
 */
const isShowPreviewList = (isMostRecentOrderDetailFetching, orderItems, ordersListItems) => {
  return (
    !isMostRecentOrderDetailFetching &&
    orderItems &&
    orderItems.length > 0 &&
    ordersListItems &&
    ordersListItems.length
  );
};

const getPastYearsList = (years, orderLabels) => {
  const currentYear = new Date().getFullYear();
  const currentDate = new Date();
  const pastYears = [];
  const lastSixMonths = new Date().setMonth(currentDate.getMonth() - 6);
  const last12Months = new Date().setMonth(currentDate.getMonth() - 12);

  pastYears.push({
    year: currentYear,
    startDate: lastSixMonths ? new Date(lastSixMonths).toISOString() : '',
    endDate: currentDate.toISOString(),
    label: getLabelWithDefaultValue(orderLabels, lblExtendedLast6Months),
    id: `${currentYear}_0`,
    pastOrder: false,
    showLoadMore: false,
  });

  pastYears.push({
    year: currentYear,
    startDate: last12Months ? new Date(last12Months).toISOString() : '',
    endDate: lastSixMonths ? new Date(lastSixMonths).toISOString() : '',
    label: getLabelWithDefaultValue(orderLabels, lblExtendedLast12Months),
    id: `${currentYear}_1`,
    pastOrder: true,
    showLoadMore: false,
  });

  const pastYearsCount = Array.from({ length: years - 1 }, (_, i) => i + 2);
  pastYearsCount.forEach((i) => {
    const pastYear = currentYear + 1 - i;
    pastYears.push({
      year: pastYear,
      startDate: new Date(pastYear, 0, 1).toISOString(),
      endDate: new Date(pastYear, 11, 31).toISOString(),
      label: pastYear,
      id: `${pastYear}_${i}`,
      pastOrder: true,
      showLoadMore: false,
    });
  });

  return pastYears;
};

const getSelectedFilterOption = (option, selectedYear) => {
  return selectedYear?.id === option;
};
const getFilteredData = (ordersListItems, selectedYear) => {
  const startDate = moment(selectedYear?.startDate).utc().format();
  const endDate = moment(selectedYear?.endDate).utc().format();
  return ordersListItems?.filter((item) => {
    const date = moment(item?.orderDateWithoutFormatting?.toString(), 'LL').utc().format();
    if (selectedYear?.pastOrder) {
      if (date >= startDate && date <= endDate) {
        if (item?.isPastOrder) {
          return item;
        }
        return null;
      }
    } else if (date >= startDate && date <= endDate) {
      return item;
    }
    return null;
  });
};

const getOrderBasedOnFilter = ({
  item,
  setSelectedOrdersYearAction,
  toggleFilterModalAction,
  setPaginationAction,
  selectedYear,
  loadMoreOrders,
  index,
  loadOrdersBasedOnFilter,
  ordersListItems,
  orderFilterOptions,
  setLoadMore,
}) => {
  const { pastOrder } = item;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  window.onscroll = function () {
    window.scrollTo(scrollLeft, scrollTop);
  };
  setSelectedOrdersYearAction(item);
  toggleFilterModalAction(false);
  setLocalStorage({ key: 'ORDER_FILTER', value: JSON.stringify(item) });
  const currentSelectedYear = orderFilterOptions?.find((data) => data?.id === item?.id);
  const isInitialFetch =
    (!currentSelectedYear?.pastOrder && currentSelectedYear?.initialFetch) || false;
  const currentFilterDataPresent = !pastOrder ? getFilteredData(ordersListItems, item) : [];
  if (selectedYear?.id !== item?.id && currentFilterDataPresent?.length === 0 && !isInitialFetch) {
    if (index === 0) {
      loadMoreOrders();
    } else {
      loadOrdersBasedOnFilter(item, { fromDropDown: true });
    }
    setPaginationAction(0);
  }

  if (currentFilterDataPresent.length > 0) {
    setLoadMore(true);
  }

  return false;
};

const getToolTipMsg = ({
  selectedYear,
  setSelectedOrdersYearAction,
  loadMoreOrders,
  loadOrdersBasedOnFilter,
  setPaginationAction,
  noOfPastYears,
  orderLabels,
  toggleFilterModalAction,
  ordersListItems,
  orderFilterOptions,
  setLoadMore,
}) => {
  const pastYearList = getPastYearsList(noOfPastYears, orderLabels);
  return (
    <div>
      {pastYearList?.map((item, index) => {
        return (
          <div>
            <Field
              key={item.id}
              component={LabeledRadioButton}
              name="orderFilters"
              checked={getSelectedFilterOption(item.id, selectedYear)}
              title={item.label}
              className="order-filters-radio"
              onClick={() => {
                setTimeout(() => {
                  getOrderBasedOnFilter({
                    item,
                    setSelectedOrdersYearAction,
                    toggleFilterModalAction,
                    setPaginationAction,
                    selectedYear,
                    loadMoreOrders,
                    index,
                    loadOrdersBasedOnFilter,
                    ordersListItems,
                    orderFilterOptions,
                    setLoadMore,
                  });
                }, 0);
              }}
            />
          </div>
        );
      })}
    </div>
  );
};

const getNewOrderList = ({ orderHistoryExtendedEnabled, filteredOrderList, ordersListItems }) => {
  return orderHistoryExtendedEnabled ? filteredOrderList : ordersListItems;
};

const getOrderListItemsPresent = ({
  orderHistoryExtendedEnabled,
  filteredOrderList,
  ordersListItems,
}) => {
  return orderHistoryExtendedEnabled
    ? filteredOrderList && filteredOrderList?.length
    : ordersListItems && ordersListItems?.length;
};

const headingProps = {
  headingStyle: {
    className: 'modal-heading',
  },
};

const getHeader = ({
  orderLabels,
  orderHistoryExtendedEnabled,
  plccToolTipMessage,
  selectedYear,
  filterModalState,
  toggleFilterModalAction,
  className,
}) => {
  return (
    <div className={`order-filter-cont`}>
      <FormPageHeading
        className="elem-mb-XL new-page-heading"
        heading={getLabelWithDefaultValue(orderLabels, lblOrdersHeadingHistory)}
      />
      {orderHistoryExtendedEnabled && !isMobileWeb() && (
        <ReactToolTip
          id="tool"
          direction="orderList-right"
          message={plccToolTipMessage}
          maxWidth={248}
          plccTooltip
          filterModalState={filterModalState}
          toggleFilterModalAction={toggleFilterModalAction}
          fromOrderFilter
        >
          <div className="tooltip-cont">
            <Button
              className="order-filter-cta"
              type="button"
              aria-label="Filter"
              fill="WHITE"
              fontSize="fs14"
              fontWeight="semibold"
              color="white"
              onClick={() => toggleFilterModalAction(!filterModalState)}
            >
              <Image
                className="header-icon elem-mr-XS elem-ml-XS  "
                width="21px"
                height="21px"
                src={getIconPath('filter-1')}
                alt="reward-icon"
                data-locator="reward-icon"
                aria-hidden="true"
              />
              <BodyCopy
                fontSize="fs14"
                component="span"
                fontFamily="secondary"
                fontWeight="semibold"
              >
                {selectedYear?.label}
              </BodyCopy>
            </Button>
          </div>
        </ReactToolTip>
      )}
      {isMobileWeb() && orderHistoryExtendedEnabled && (
        <div>
          <Button
            className="order-filter-cta"
            type="button"
            aria-label="Filter"
            fill="WHITE"
            fontSize="fs14"
            fontWeight="semibold"
            color="white"
            onClick={() => toggleFilterModalAction(true)}
          >
            <Image
              className="header-icon elem-mr-XS elem-ml-XS  "
              width="21px"
              height="21px"
              src={getIconPath('filter-1')}
              alt="reward-icon"
              data-locator="reward-icon"
              aria-hidden="true"
            />
            <BodyCopy fontSize="fs14" component="span" fontFamily="secondary" fontWeight="semibold">
              {selectedYear?.label}
            </BodyCopy>
          </Button>
          <Modal
            fixedWidth
            isOpen={filterModalState}
            onRequestClose={() => {
              toggleFilterModalAction(false);
            }}
            heading="Filter Display"
            headingAlign="center"
            overlayClassName="TCPModal__Overlay"
            className={`${className} TCPModal__Content modal-container`}
            innerContentClassName="editModal-innerContent"
            headingFontWeight="bold"
            headingFontFamily="secondary"
            inheritedStyles={modalStyles}
            {...headingProps}
          >
            {plccToolTipMessage}
          </Modal>
        </div>
      )}
    </div>
  );
};

const getLoadMoreStateBasedOnFilter = ({ orderFilterOptions, selectedYear }) => {
  const selectYear = orderFilterOptions?.find((item) => item?.id === selectedYear?.id);
  return selectYear?.showLoadMore;
};

const getEmptyLabel = ({ selectedYear }) => {
  const label = getDynamicLabelValues(`dynamic.account_d.${lblEmptyOrdersText4}`) || '';
  return label?.replace('*year*', selectedYear?.label);
};

const getShowHeader = (
  isMostRecentOrderFetching,
  ordersListItems,
  upcomingOrders,
  upcomingOrdersPresent,
  orderListItemsPresent
) => {
  return (
    !(
      isMostRecentOrderFetching &&
      (ordersListItems?.length === 0 || upcomingOrders?.length === 0) &&
      !(upcomingOrdersPresent || orderListItemsPresent)
    ) &&
    (orderListItemsPresent || isMostRecentOrderFetching)
  );
};

const getRenderNewOrderList = (
  isMostRecentOrderFetching,
  orderHistoryExtendedEnabled,
  upcomingOrdersPresent,
  isLoadMoreActive,
  newOrderList
) => {
  return (
    !isMostRecentOrderFetching &&
    orderHistoryExtendedEnabled &&
    upcomingOrdersPresent &&
    !isLoadMoreActive &&
    newOrderList?.length === 0
  );
};

export const OrderListContent = ({
  ordersListItems,
  orderLabels,
  isLoadMoreActive,
  loadMoreOrders,
  showOrderListWithItemDetails,
  isMostRecentOrderFetching,
  upcomingOrdersPresent,
  cshReturnItemOlderDays,
  setOrderResendModalOpen,
  isCSHEnabled,
  isBOSSOrderStatusEnabled,
  isCrossBrandMerchandisingEnabled,
  isBIAEnabledForOrderHistory,
  ordersLoader,
  loadOrdersBasedOnFilter,
  setSelectedOrdersYearAction,
  selectedYear,
  setPaginationAction,
  orderHistoryExtendedEnabled,
  noOfPastYears,
  className,
  filterModalState,
  toggleFilterModalAction,
  upcomingOrders,
  setCompanyIDAction,
  companyId,
  setFilterOptionsAction,
  orderFilterOptions,
  orderListState,
  isAddAltPickupPersonEnabled,
  altPickupPersonLimit,
  altPickupPersonInvaildOrderStatus,
  isOrderError,
  setLoadMore,
  ...otherprops
}) => {
  const filteredOrderList = getFilteredData(ordersListItems, selectedYear);
  const newOrderList = getNewOrderList({
    orderHistoryExtendedEnabled,
    filteredOrderList,
    ordersListItems,
  });
  const orderListItemsPresent = getOrderListItemsPresent({
    orderHistoryExtendedEnabled,
    selectedYear,
    filteredOrderList,
    ordersListItems,
  });
  const plccToolTipMessage = getToolTipMsg({
    selectedYear,
    setSelectedOrdersYearAction,
    loadMoreOrders,
    loadOrdersBasedOnFilter,
    setPaginationAction,
    noOfPastYears,
    orderLabels,
    toggleFilterModalAction,
    ordersListItems,
    orderFilterOptions,
    setLoadMore,
  });

  const showHeader = getShowHeader(
    isMostRecentOrderFetching,
    ordersListItems,
    upcomingOrders,
    upcomingOrdersPresent,
    orderListItemsPresent
  );
  return (
    <>
      {showHeader
        ? getHeader({
            orderLabels,
            orderHistoryExtendedEnabled,
            plccToolTipMessage,
            selectedYear,
            filterModalState,
            toggleFilterModalAction,
            className,
          })
        : null}
      {getRenderNewOrderList(
        isMostRecentOrderFetching,
        orderHistoryExtendedEnabled,
        upcomingOrdersPresent,
        isLoadMoreActive,
        newOrderList
      ) && (
        <div>
          {getHeader({
            orderLabels,
            orderHistoryExtendedEnabled,
            plccToolTipMessage,
            selectedYear,
            filterModalState,
            toggleFilterModalAction,
            className,
          })}
          {selectedYear?.pastOrder ? (
            <div className="empty-text-cont">
              <BodyCopy
                fontSize="fs16"
                component="span"
                fontFamily="secondary"
                fontWeight="regular"
              >
                {getEmptyLabel({ selectedYear })}
              </BodyCopy>
            </div>
          ) : (
            <div className="empty-text-cont">
              <BodyCopy
                fontSize="fs16"
                component="span"
                fontFamily="secondary"
                fontWeight="regular"
              >
                {getLabelWithDefaultValue(orderLabels, lblEmptyOrdersText1)}
              </BodyCopy>
              <BodyCopy fontSize="fs16" component="span" fontFamily="secondary" fontWeight="bold">
                {getLabelWithDefaultValue(orderLabels, lblEmptyOrdersText2)}
              </BodyCopy>
            </div>
          )}
        </div>
      )}
      {orderListItemsPresent || upcomingOrdersPresent ? (
        <div className="bottom-section-container">
          {orderListItemsPresent ? (
            <OrderListWithDetails
              ordersListItems={newOrderList}
              cshReturnItemOlderDays={cshReturnItemOlderDays}
              setOrderResendModalOpen={setOrderResendModalOpen}
              isCSHEnabled={isCSHEnabled}
              isBOSSOrderStatusEnabled={isBOSSOrderStatusEnabled}
              isCrossBrandMerchandisingEnabled={isCrossBrandMerchandisingEnabled}
              selectedYear={selectedYear}
              isAddAltPickupPersonEnabled={isAddAltPickupPersonEnabled}
              altPickupPersonLimit={altPickupPersonLimit}
              altPickupPersonInvaildOrderStatus={altPickupPersonInvaildOrderStatus}
            />
          ) : null}
          {isMostRecentOrderFetching && <LoaderSkelton className="skeletonStyle" />}

          {(isLoadMoreActive ||
            getLoadMoreStateBasedOnFilter({ orderFilterOptions, selectedYear })) && (
            <div className="load-more">
              <Button
                className="load-more-cta"
                type="button"
                aria-label="LoadMore"
                fill="WHITE"
                fontSize="fs12"
                fontWeight="extrabold"
                color="darkergray"
                buttonVariation="fixed-width"
                onClick={() => {
                  setTimeout(() => {
                    if (selectedYear?.pastOrder) {
                      loadOrdersBasedOnFilter(selectedYear, { fromPastLoadMore: true });
                    } else {
                      loadMoreOrders();
                    }
                  }, 0);
                }}
                disabled={isMostRecentOrderFetching}
              >
                {getLabelWithDefaultValue(orderLabels, lblOrdersLoadMore)}
              </Button>
            </div>
          )}
        </div>
      ) : (
        <div className="empty-orders-list-wrapper empty-back-nav-link">
          {!ordersLoader && !isMostRecentOrderFetching && (
            <div>
              {getHeader({
                orderLabels,
                orderHistoryExtendedEnabled,
                plccToolTipMessage,
                selectedYear,
                filterModalState,
                toggleFilterModalAction,
                className,
              })}
              {isOrderError ? (
                <BodyCopy
                  fontSize={isMobileWeb() ? 'fs14' : 'fs16'}
                  component="span"
                  fontFamily="secondary"
                  fontWeight="regular"
                >
                  {isOrderError?.message}
                </BodyCopy>
              ) : (
                <EmptyOrdersList
                  fromOrderList={orderHistoryExtendedEnabled}
                  selectedYear={selectedYear}
                  emptyLabel={getEmptyLabel}
                />
              )}
            </div>
          )}
        </div>
      )}
      <OrdersLinks
        showOrderListWithItemDetails={showOrderListWithItemDetails}
        isPageEmpty={!orderListItemsPresent && !upcomingOrdersPresent}
        cshReturnItemOlderDays={cshReturnItemOlderDays}
        setOrderResendModalOpen={setOrderResendModalOpen}
        isCSHEnabled={isCSHEnabled}
        isBIAEnabledForOrderHistory={isBIAEnabledForOrderHistory}
        setCompanyIDAction={setCompanyIDAction}
        companyId={companyId}
        {...otherprops}
      />
    </>
  );
};

OrderListContent.propTypes = {
  isLoadMoreActive: PropTypes.bool,
  showOrderListWithItemDetails: PropTypes.bool,
  upcomingOrdersPresent: PropTypes.bool.isRequired,
  ordersListItems: PropTypes.shape([]).isRequired,
  loadMoreOrders: PropTypes.func.isRequired,
  isMostRecentOrderFetching: PropTypes.bool,
};
OrderListContent.defaultProps = {
  isLoadMoreActive: true,
  showOrderListWithItemDetails: true,
  isMostRecentOrderFetching: false,
};
const getClassName = (isBIAEnabledForOrderHistory, isBIAAvailProduct) => {
  return isBIAEnabledForOrderHistory && isBIAAvailProduct
    ? 'back-link'
    : 'account-dashboard-goback-link';
};

const getOrderLoader = ({ isMostRecentOrderFetching, ordersListItems, upcomingOrders }) => {
  const upcomingOrdersPresent = upcomingOrders && upcomingOrders.length > 0;
  const ordersListItemsPresent = ordersListItems && ordersListItems.length > 0;
  return (
    isMostRecentOrderFetching &&
    (!upcomingOrdersPresent || !ordersListItemsPresent) && (
      <div>
        <LoaderSkelton className="skeletonStyle" />
      </div>
    )
  );
};

const renderBIA = (isMostRecentOrderFetching, isBIAEnabledForOrderHistory) => {
  return isBIAEnabledForOrderHistory && <BIAOrderHistory />;
};

const onScroll = () => {
  window.onscroll = function () {};
};

const OrdersList = ({
  orderItems,
  ordersListItems,
  isMostRecentOrderFetching,
  isMostRecentOrderDetailFetching,
  showOrderListWithItemDetails,
  className,
  upcomingOrders,
  loadMoreOrders,
  isLoadMoreActive,
  cshReturnItemOlderDays,
  setOrderResendModalOpen,
  isCSHEnabled,
  isBOSSOrderStatusEnabled,
  isCrossBrandMerchandisingEnabled,
  isBIAEnabledForOrderHistory,
  biaProducts,
  route,
  isBIAAvailProduct,
  ordersLoader,
  setPaginationAction,
  setSelectedOrdersYearAction,
  orderHistoryExtendedEnabled,
  filterModalState,
  toggleFilterModalAction,
  noOfPastYears,
  setCompanyIDAction,
  companyId,
  setFilterOptionsAction,
  orderFilterOptions,
  isAddAltPickupPersonEnabled,
  altPickupPersonLimit,
  altPickupPersonInvaildOrderStatus,
  setLoadMore,
  ...otherprops
}) => {
  const orderLabels = getLabelFromCopyOrFromTranslation(ACCOUNT_ORDERS_LABEL, OrderDetailLabels);

  useEffect(() => {
    if (showOrderListWithItemDetails) {
      window.scrollTo(0, 0);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    if (orderHistoryExtendedEnabled) {
      const filterOptions = getPastYearsList(noOfPastYears, orderLabels);
      setFilterOptionsAction(filterOptions);
      const currentYear = new Date().getFullYear();
      const lastSixMonths = new Date().setMonth(new Date().getMonth() - 6);
      const currentDate = new Date();
      const defaultYear = {
        year: currentYear,
        startDate: lastSixMonths ? new Date(lastSixMonths).toISOString() : '',
        endDate: currentDate ? new Date(currentDate).toISOString() : '',
        label: getLabelWithDefaultValue(orderLabels, lblExtendedLast6Months),
        id: `${currentYear}_${0}`,
        pastOrder: false,
      };
      const localData = JSON.parse(getLocalStorage('ORDER_FILTER'));
      if (localData) {
        setSelectedOrdersYearAction(localData);
      } else {
        setSelectedOrdersYearAction(defaultYear);
      }
    }

    return () => window.addEventListener('scroll', onScroll, { passive: true });
  }, []);
  if (showOrderListWithItemDetails) {
    const upcomingOrdersPresent = upcomingOrders && upcomingOrders?.length > 0;
    return (
      <div>
        <BodyCopy
          component="div"
          className={`elem-mb-MED elem-ml-XS ${getClassName(
            isBIAEnabledForOrderHistory,
            isBIAAvailProduct
          )}`}
        >
          <Anchor
            fontSizeVariation="xlarge"
            anchorVariation="secondary"
            to="/account?id=account-overview"
            asPath="/account"
          >
            <span className="left-arrow" />
            {getLabelFromCopyOrFromTranslation(
              `${GLOBAL_ACTIONS_LABELS}.${lblBack}`,
              GlobalActionsLabels
            )}
          </Anchor>
        </BodyCopy>
        <div className={`${className} order-back-button`}>
          <BodyCopy component="div" className="orders-tile-heading">
            <div className="orders-tile-heading-left">
              <Image src={`${getIconPath('orders')}`} alt={'Orders Icon'} className="orders-icon" />
              <span className="orders-tile-heading-text">
                {getLabelFromCopyOrFromTranslation(
                  `${ACCOUNT_OVERVIEW_LABEL}.${lblOverviewOrderHeading}`,
                  OrderTileLabels
                )}
              </span>
            </div>
          </BodyCopy>

          {renderBIA(isMostRecentOrderFetching, isBIAEnabledForOrderHistory)}
          {getOrderLoader({ isMostRecentOrderFetching, ordersListItems, upcomingOrders })}
          {upcomingOrdersPresent ? (
            <>
              <FormPageHeading
                className="elem-mb-XL new-page-heading"
                heading={getLabelWithDefaultValue(orderLabels, lblOrdersHeadingUpcoming)}
              />
              <OrderListWithDetails
                ordersListItems={upcomingOrders}
                cshReturnItemOlderDays={cshReturnItemOlderDays}
                upcomingOrdersView
                setOrderResendModalOpen={setOrderResendModalOpen}
                isCSHEnabled={isCSHEnabled}
                isBOSSOrderStatusEnabled={isBOSSOrderStatusEnabled}
                isCrossBrandMerchandisingEnabled={isCrossBrandMerchandisingEnabled}
                isAddAltPickupPersonEnabled={isAddAltPickupPersonEnabled}
                altPickupPersonLimit={altPickupPersonLimit}
                altPickupPersonInvaildOrderStatus={altPickupPersonInvaildOrderStatus}
              />
            </>
          ) : null}

          <OrderListContent
            loadMoreOrders={loadMoreOrders}
            ordersListItems={ordersListItems}
            orderLabels={orderLabels}
            upcomingOrdersPresent={upcomingOrdersPresent}
            isLoadMoreActive={isLoadMoreActive}
            {...otherprops}
            showOrderListWithItemDetails={showOrderListWithItemDetails}
            isMostRecentOrderFetching={isMostRecentOrderFetching}
            cshReturnItemOlderDays={cshReturnItemOlderDays}
            setOrderResendModalOpen={setOrderResendModalOpen}
            isCSHEnabled={isCSHEnabled}
            isBOSSOrderStatusEnabled={isBOSSOrderStatusEnabled}
            isCrossBrandMerchandisingEnabled={isCrossBrandMerchandisingEnabled}
            isBIAEnabledForOrderHistory={isBIAEnabledForOrderHistory}
            ordersLoader={ordersLoader}
            setPaginationAction={setPaginationAction}
            setSelectedOrdersYearAction={setSelectedOrdersYearAction}
            orderHistoryExtendedEnabled={orderHistoryExtendedEnabled}
            className={className}
            filterModalState={filterModalState}
            toggleFilterModalAction={toggleFilterModalAction}
            upcomingOrders={upcomingOrders}
            noOfPastYears={noOfPastYears}
            setCompanyIDAction={setCompanyIDAction}
            companyId={companyId}
            orderFilterOptions={orderFilterOptions}
            setFilterOptionsAction={setFilterOptionsAction}
            isAddAltPickupPersonEnabled={isAddAltPickupPersonEnabled}
            altPickupPersonLimit={altPickupPersonLimit}
            altPickupPersonInvaildOrderStatus={altPickupPersonInvaildOrderStatus}
            setLoadMore={setLoadMore}
          />
        </div>
      </div>
    );
  }
  return (
    <React.Fragment>
      <FormPageHeading
        className="elem-mb-XL myAccountRightView"
        heading={getLabelWithDefaultValue(orderLabels, lblOrdersHeading)}
        data-locator="OrdersListPageLbl"
      />
      <OrdersLinks setCompanyIDAction={setCompanyIDAction} companyId={companyId} {...otherprops} />
      {isMostRecentOrderFetching && <RecentOrdersSkeleton />}
      {!isMostRecentOrderFetching && <RecentOrders ordersListItems={ordersListItems} />}
      {isMostRecentOrderDetailFetching && <OrderPreviewItemsListSkeleton />}

      {isShowPreviewList(isMostRecentOrderDetailFetching, orderItems, ordersListItems) ? (
        <OrderPreviewItemsList
          items={orderItems.slice(0, 3)}
          orderNumber={ordersListItems[0].orderNumber}
          trackingUrl={ordersListItems[0].orderTrackingUrl}
        />
      ) : null}
      {ordersListItems && ordersListItems.length > 1 ? (
        <PastOrders ordersListItems={ordersListItems} />
      ) : null}
    </React.Fragment>
  );
};

OrdersList.propTypes = {
  ordersListItems: PropTypes.shape([]).isRequired,
  orderItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isMostRecentOrderFetching: PropTypes.bool,
  isMostRecentOrderDetailFetching: PropTypes.bool,
  showOrderListWithItemDetails: PropTypes.bool,
  className: PropTypes.string,
  loadMoreOrders: PropTypes.func.isRequired,
  upcomingOrders: PropTypes.shape([]),
  isLoadMoreActive: PropTypes.bool,
};

OrdersList.defaultProps = {
  isMostRecentOrderFetching: false,
  isMostRecentOrderDetailFetching: false,
  showOrderListWithItemDetails: false,
  className: '',
  upcomingOrders: [],
  isLoadMoreActive: true,
};

export default reduxForm({
  form: 'orderFilters',
  enableReinitialize: true,
})(withStyles(OrdersList, styles));
export { OrdersList };
